import { api } from 'utility';
import queryString from 'query-string';
import {
  getReportOfflineUrl,
} from 'URLs';

/**
* دریافت لیست گزارش های آفلاین 
*/
export function getRportOfflineRequest(params, isAllData = false) {
  return api.get(`${getReportOfflineUrl()}?${queryString.stringify(params)}`).then((res) => res.data);
}


export default {
  getRportOfflineRequest,

};
